import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _awaitAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";

var _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

// pkg/dist-src/index.js
import { Octokit as OctokitCore } from "@octokit/core";
import { createAppAuth as createAppAuth3 } from "@octokit/auth-app";
import { OAuthApp } from "@octokit/oauth-app";
import { Webhooks as Webhooks2 } from "@octokit/webhooks"; // pkg/dist-src/version.js

var VERSION = "14.0.2"; // pkg/dist-src/webhooks.js

import { Octokit } from "@octokit/core";
import { createAppAuth } from "@octokit/auth-app";
import { createUnauthenticatedAuth } from "@octokit/auth-unauthenticated";
import { Webhooks } from "@octokit/webhooks";

function webhooks(appOctokit, options) {
  return new Webhooks({
    secret: options.secret,
    transform: function () {
      var _transform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var octokit2, installationId, octokit;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!("installation" in event.payload) || typeof event.payload.installation !== "object")) {
                  _context.next = 3;
                  break;
                }

                octokit2 = new appOctokit.constructor({
                  authStrategy: createUnauthenticatedAuth,
                  auth: {
                    reason: "\"installation\" key missing in webhook event payload"
                  }
                });
                return _context.abrupt("return", _objectSpread(_objectSpread({}, event), {}, {
                  octokit: octokit2
                }));

              case 3:
                installationId = event.payload.installation.id;
                _context.next = 6;
                return appOctokit.auth({
                  type: "installation",
                  installationId: installationId,
                  factory: function factory(auth) {
                    return new auth.octokit.constructor(_objectSpread(_objectSpread({}, auth.octokitOptions), {}, {
                      authStrategy: createAppAuth
                    }, {
                      auth: _objectSpread(_objectSpread({}, auth), {}, {
                        installationId: installationId
                      })
                    }));
                  }
                });

              case 6:
                octokit = _context.sent;
                octokit.hook.before("request", function (options2) {
                  options2.headers["x-github-delivery"] = event.id;
                });
                return _context.abrupt("return", _objectSpread(_objectSpread({}, event), {}, {
                  octokit: octokit
                }));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function transform(_x) {
        return _transform.apply(this, arguments);
      }

      return transform;
    }()
  });
} // pkg/dist-src/each-installation.js


import { composePaginateRest } from "@octokit/plugin-paginate-rest";
import { Octokit as Octokit3 } from "@octokit/core"; // pkg/dist-src/get-installation-octokit.js

import { createAppAuth as createAppAuth2 } from "@octokit/auth-app";
import { Octokit as Octokit2 } from "@octokit/core";

function getInstallationOctokit(_x2, _x3) {
  return _getInstallationOctokit.apply(this, arguments);
} // pkg/dist-src/each-installation.js


function _getInstallationOctokit() {
  _getInstallationOctokit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(app, installationId) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", app.octokit.auth({
              type: "installation",
              installationId: installationId,
              factory: function factory(auth) {
                var options = _objectSpread(_objectSpread({}, auth.octokitOptions), {}, {
                  authStrategy: createAppAuth2
                }, {
                  auth: _objectSpread(_objectSpread({}, auth), {}, {
                    installationId: installationId
                  })
                });

                return new auth.octokit.constructor(options);
              }
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getInstallationOctokit.apply(this, arguments);
}

function eachInstallationFactory(app) {
  return Object.assign(eachInstallation.bind(null, app), {
    iterator: eachInstallationIterator.bind(null, app)
  });
}

function eachInstallation(_x4, _x5) {
  return _eachInstallation.apply(this, arguments);
}

function _eachInstallation() {
  _eachInstallation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(app, callback) {
    var i, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            i = eachInstallationIterator(app)[Symbol.asyncIterator]();
            _context6.next = 3;
            return i.next();

          case 3:
            result = _context6.sent;

          case 4:
            if (result.done) {
              _context6.next = 12;
              break;
            }

            _context6.next = 7;
            return callback(result.value);

          case 7:
            _context6.next = 9;
            return i.next();

          case 9:
            result = _context6.sent;
            _context6.next = 4;
            break;

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _eachInstallation.apply(this, arguments);
}

function eachInstallationIterator(app) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var iterator, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, installations, _iterator4, _step4, installation, installationOctokit;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              iterator = composePaginateRest.iterator(app.octokit, "GET /app/installations");
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.prev = 3;
              _iterator = _asyncIterator(iterator);

            case 5:
              _context2.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                _context2.next = 32;
                break;
              }

              installations = _step.value.data;
              _iterator4 = _createForOfIteratorHelper(installations);
              _context2.prev = 10;

              _iterator4.s();

            case 12:
              if ((_step4 = _iterator4.n()).done) {
                _context2.next = 21;
                break;
              }

              installation = _step4.value;
              _context2.next = 16;
              return _awaitAsyncGenerator(getInstallationOctokit(app, installation.id));

            case 16:
              installationOctokit = _context2.sent;
              _context2.next = 19;
              return {
                octokit: installationOctokit,
                installation: installation
              };

            case 19:
              _context2.next = 12;
              break;

            case 21:
              _context2.next = 26;
              break;

            case 23:
              _context2.prev = 23;
              _context2.t0 = _context2["catch"](10);

              _iterator4.e(_context2.t0);

            case 26:
              _context2.prev = 26;

              _iterator4.f();

              return _context2.finish(26);

            case 29:
              _iteratorAbruptCompletion = false;
              _context2.next = 5;
              break;

            case 32:
              _context2.next = 38;
              break;

            case 34:
              _context2.prev = 34;
              _context2.t1 = _context2["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 38:
              _context2.prev = 38;
              _context2.prev = 39;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context2.next = 43;
                break;
              }

              _context2.next = 43;
              return _awaitAsyncGenerator(_iterator.return());

            case 43:
              _context2.prev = 43;

              if (!_didIteratorError) {
                _context2.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context2.finish(43);

            case 47:
              return _context2.finish(38);

            case 48:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 34, 38, 48], [10, 23, 26, 29], [39,, 43, 47]]);
    }))();
  });
} // pkg/dist-src/each-repository.js


import { composePaginateRest as composePaginateRest2 } from "@octokit/plugin-paginate-rest";
import { Octokit as Octokit4 } from "@octokit/core";

function eachRepositoryFactory(app) {
  return Object.assign(eachRepository.bind(null, app), {
    iterator: eachRepositoryIterator.bind(null, app)
  });
}

function eachRepository(_x6, _x7, _x8) {
  return _eachRepository.apply(this, arguments);
}

function _eachRepository() {
  _eachRepository = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(app, queryOrCallback, callback) {
    var i, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            i = eachRepositoryIterator(app, callback ? queryOrCallback : void 0)[Symbol.asyncIterator]();
            _context7.next = 3;
            return i.next();

          case 3:
            result = _context7.sent;

          case 4:
            if (result.done) {
              _context7.next = 17;
              break;
            }

            if (!callback) {
              _context7.next = 10;
              break;
            }

            _context7.next = 8;
            return callback(result.value);

          case 8:
            _context7.next = 12;
            break;

          case 10:
            _context7.next = 12;
            return queryOrCallback(result.value);

          case 12:
            _context7.next = 14;
            return i.next();

          case 14:
            result = _context7.sent;
            _context7.next = 4;
            break;

          case 17:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _eachRepository.apply(this, arguments);
}

function singleInstallationIterator(app, installationId) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _awaitAsyncGenerator(app.getInstallationOctokit(installationId));

            case 2:
              _context3.t0 = _context3.sent;
              _context3.next = 5;
              return {
                octokit: _context3.t0
              };

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  });
}

function eachRepositoryIterator(app, query) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var iterator, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, octokit, repositoriesIterator, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, repositories, _iterator5, _step5, repository;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              iterator = query ? singleInstallationIterator(app, query.installationId) : app.eachInstallation.iterator();
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context4.prev = 3;
              _iterator2 = _asyncIterator(iterator);

            case 5:
              _context4.next = 7;
              return _awaitAsyncGenerator(_iterator2.next());

            case 7:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                _context4.next = 57;
                break;
              }

              octokit = _step2.value.octokit;
              repositoriesIterator = composePaginateRest2.iterator(octokit, "GET /installation/repositories");
              _iteratorAbruptCompletion3 = false;
              _didIteratorError3 = false;
              _context4.prev = 12;
              _iterator3 = _asyncIterator(repositoriesIterator);

            case 14:
              _context4.next = 16;
              return _awaitAsyncGenerator(_iterator3.next());

            case 16:
              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context4.sent).done)) {
                _context4.next = 38;
                break;
              }

              repositories = _step3.value.data;
              _iterator5 = _createForOfIteratorHelper(repositories);
              _context4.prev = 19;

              _iterator5.s();

            case 21:
              if ((_step5 = _iterator5.n()).done) {
                _context4.next = 27;
                break;
              }

              repository = _step5.value;
              _context4.next = 25;
              return {
                octokit: octokit,
                repository: repository
              };

            case 25:
              _context4.next = 21;
              break;

            case 27:
              _context4.next = 32;
              break;

            case 29:
              _context4.prev = 29;
              _context4.t0 = _context4["catch"](19);

              _iterator5.e(_context4.t0);

            case 32:
              _context4.prev = 32;

              _iterator5.f();

              return _context4.finish(32);

            case 35:
              _iteratorAbruptCompletion3 = false;
              _context4.next = 14;
              break;

            case 38:
              _context4.next = 44;
              break;

            case 40:
              _context4.prev = 40;
              _context4.t1 = _context4["catch"](12);
              _didIteratorError3 = true;
              _iteratorError3 = _context4.t1;

            case 44:
              _context4.prev = 44;
              _context4.prev = 45;

              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                _context4.next = 49;
                break;
              }

              _context4.next = 49;
              return _awaitAsyncGenerator(_iterator3.return());

            case 49:
              _context4.prev = 49;

              if (!_didIteratorError3) {
                _context4.next = 52;
                break;
              }

              throw _iteratorError3;

            case 52:
              return _context4.finish(49);

            case 53:
              return _context4.finish(44);

            case 54:
              _iteratorAbruptCompletion2 = false;
              _context4.next = 5;
              break;

            case 57:
              _context4.next = 63;
              break;

            case 59:
              _context4.prev = 59;
              _context4.t2 = _context4["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t2;

            case 63:
              _context4.prev = 63;
              _context4.prev = 64;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context4.next = 68;
                break;
              }

              _context4.next = 68;
              return _awaitAsyncGenerator(_iterator2.return());

            case 68:
              _context4.prev = 68;

              if (!_didIteratorError2) {
                _context4.next = 71;
                break;
              }

              throw _iteratorError2;

            case 71:
              return _context4.finish(68);

            case 72:
              return _context4.finish(63);

            case 73:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 59, 63, 73], [12, 40, 44, 54], [19, 29, 32, 35], [45,, 49, 53], [64,, 68, 72]]);
    }))();
  });
} // pkg/dist-src/middleware/node/index.js


import { createNodeMiddleware as oauthNodeMiddleware, sendNodeResponse, unknownRouteResponse } from "@octokit/oauth-app";
import { createNodeMiddleware as webhooksNodeMiddleware } from "@octokit/webhooks";

function noop() {}

function createNodeMiddleware(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var log = Object.assign({
    debug: noop,
    info: noop,
    warn: console.warn.bind(console),
    error: console.error.bind(console)
  }, options.log);

  var optionsWithDefaults = _objectSpread(_objectSpread({
    pathPrefix: "/api/github"
  }, options), {}, {
    log: log
  });

  var webhooksMiddleware = webhooksNodeMiddleware(app.webhooks, {
    path: optionsWithDefaults.pathPrefix + "/webhooks",
    log: log
  });
  var oauthMiddleware = oauthNodeMiddleware(app.oauth, {
    pathPrefix: optionsWithDefaults.pathPrefix + "/oauth"
  });
  return middleware.bind(null, optionsWithDefaults.pathPrefix, webhooksMiddleware, oauthMiddleware);
}

function middleware(_x9, _x10, _x11, _x12, _x13, _x14) {
  return _middleware.apply(this, arguments);
} // pkg/dist-src/index.js


function _middleware() {
  _middleware = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(pathPrefix, webhooksMiddleware, oauthMiddleware, request, response, next) {
    var _URL, pathname;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _URL = new URL(request.url, "http://localhost"), pathname = _URL.pathname;

            if (!pathname.startsWith("".concat(pathPrefix, "/"))) {
              _context8.next = 6;
              break;
            }

            if (pathname === "".concat(pathPrefix, "/webhooks")) {
              webhooksMiddleware(request, response);
            } else if (pathname.startsWith("".concat(pathPrefix, "/oauth/"))) {
              oauthMiddleware(request, response);
            } else {
              sendNodeResponse(unknownRouteResponse(request), response);
            }

            return _context8.abrupt("return", true);

          case 6:
            next === null || next === void 0 ? void 0 : next();
            return _context8.abrupt("return", false);

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _middleware.apply(this, arguments);
}

var App = (_class = /*#__PURE__*/function () {
  function App(options) {
    _classCallCheck(this, App);

    var Octokit5 = options.Octokit || OctokitCore;
    var authOptions = Object.assign({
      appId: options.appId,
      privateKey: options.privateKey
    }, options.oauth ? {
      clientId: options.oauth.clientId,
      clientSecret: options.oauth.clientSecret
    } : {});
    this.octokit = new Octokit5({
      authStrategy: createAppAuth3,
      auth: authOptions,
      log: options.log
    });
    this.log = Object.assign({
      debug: function debug() {},
      info: function info() {},
      warn: console.warn.bind(console),
      error: console.error.bind(console)
    }, options.log);

    if (options.webhooks) {
      this.webhooks = webhooks(this.octokit, options.webhooks);
    } else {
      Object.defineProperty(this, "webhooks", {
        get: function get() {
          throw new Error("[@octokit/app] webhooks option not set");
        }
      });
    }

    if (options.oauth) {
      this.oauth = new OAuthApp(_objectSpread(_objectSpread({}, options.oauth), {}, {
        clientType: "github-app",
        Octokit: Octokit5
      }));
    } else {
      Object.defineProperty(this, "oauth", {
        get: function get() {
          throw new Error("[@octokit/app] oauth.clientId / oauth.clientSecret options are not set");
        }
      });
    }

    this.getInstallationOctokit = getInstallationOctokit.bind(null, this);
    this.eachInstallation = eachInstallationFactory(this);
    this.eachRepository = eachRepositoryFactory(this);
  }

  _createClass(App, null, [{
    key: "defaults",
    value: function defaults(_defaults) {
      var AppWithDefaults = /*#__PURE__*/function (_this) {
        _inherits(AppWithDefaults, _this);

        var _super = _createSuper(AppWithDefaults);

        function AppWithDefaults() {
          _classCallCheck(this, AppWithDefaults);

          return _super.call(this, _objectSpread(_objectSpread({}, _defaults), arguments.length <= 0 ? undefined : arguments[0]));
        }

        return _createClass(AppWithDefaults);
      }(this);

      return AppWithDefaults;
    }
  }]);

  return App;
}(), _class.VERSION = VERSION, _class);
export { App, createNodeMiddleware };